module.exports = __webpack_public_path__ + "static/media/EVS_BannerSite_ProdutoNacional.f2f46bcc.webp";